import React, { useState } from 'react';
import { useUser } from '../../context/UserContext';
import { coursesService } from '../../services/firestoreService';
import { pythonCourseData } from '../../utils/addPythonCourse';
import './AddPythonCourse.css';

const AddPythonCourse = () => {
  const { user } = useUser();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleAddCourse = async () => {
    if (!user || user.type !== 'admin') {
      setMessage('❌ Only admins can add courses.');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      // Check if course already exists
      const allCourses = await coursesService.getAllCourses();
      const existingCourse = allCourses.find(
        c => c.title.toLowerCase().includes('python') && 
             c.title.toLowerCase().includes('ai') &&
             c.title.toLowerCase().includes('robotics')
      );

      const courseData = {
        ...pythonCourseData,
        createdBy: user.id
      };

      if (existingCourse) {
        // Update existing course
        await coursesService.updateCourse(existingCourse.id, courseData);
        setMessage('✅ Course updated successfully with all topics!');
      } else {
        // Create new course
        await coursesService.createCourse(courseData);
        setMessage('✅ Course created successfully with all topics!');
      }
    } catch (error) {
      console.error('Error adding/updating course:', error);
      setMessage(`❌ Error: ${error.message || 'Failed to add course'}`);
    } finally {
      setLoading(false);
    }
  };

  if (!user || user.type !== 'admin') {
    return <div>Only admins can access this page.</div>;
  }

  return (
    <div className="add-python-course">
      <h1>🐍 Add Python + AI + Robotics Course</h1>
      <div className="course-preview">
        <h2>{pythonCourseData.title}</h2>
        <p className="course-description">{pythonCourseData.description}</p>
        <div className="topics-preview">
          <h3>Topics ({pythonCourseData.topics.length}):</h3>
          <ul>
            {pythonCourseData.topics.map((topic, idx) => (
              <li key={idx}>
                <strong>{topic.name}</strong>
                <span className="hours-badge">{topic.hours}h</span>
                <div className="topic-description">{topic.description}</div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <button 
        onClick={handleAddCourse} 
        disabled={loading}
        className="add-course-btn"
      >
        {loading ? '⏳ Adding Course...' : '✨ Add/Update Course'}
      </button>
      {message && (
        <div className={`message ${message.includes('✅') ? 'success' : 'error'}`}>
          {message}
        </div>
      )}
    </div>
  );
};

export default AddPythonCourse;

